/**
 * Constants for Calendar module
 */

// CR-5459: key events surfaced by the calendar list endpoint — Approval
// Expiry (a supplier accreditation's expiry date), Contract Renewal
// (ContractPrice.valid_to) and Supplier QBR (contract review dates, plus any
// event of type QBR or titled as one). Palette per the ticket: Approval
// Expiry red, Contract Renewal blue, QBR green. Meeting is slate, not blue,
// so it cannot be mistaken for a renewal (QA, 3 and 19 Aug).
export const EVENT_TYPE_COLORS: Record<string, string> = {
  meeting: 'bg-slate-600',
  deadline: 'bg-red-500',
  delivery: 'bg-green-500',
  audit: 'bg-purple-500',
  inspection: 'bg-yellow-500',
  review: 'bg-indigo-500',
  training: 'bg-pink-500',
  other: 'bg-gray-500',
  approval_expiry: 'bg-rose-600',
  contract_renewal: 'bg-blue-600',
  qbr: 'bg-emerald-600',
  // NCR-related event types (client feedback)
  ncr_response_due: 'bg-orange-500',
  ncr_car_due: 'bg-amber-600',
  action_due: 'bg-red-600',
  // Audit Lite: an open corrective action from a supplier audit (customer side).
  audit_action_due: 'bg-amber-500',
};

export const EVENT_TYPE_BG_COLORS: Record<string, string> = {
  meeting: '#475569',
  deadline: '#ef4444',
  delivery: '#10b981',
  audit: '#a855f7',
  inspection: '#eab308',
  review: '#6366f1',
  training: '#ec4899',
  other: '#6b7280',
  approval_expiry: '#e11d48',
  contract_renewal: '#2563eb',
  qbr: '#059669',
  // NCR-related event types (client feedback)
  ncr_response_due: '#f97316',
  ncr_car_due: '#d97706',
  action_due: '#dc2626',
  audit_action_due: '#f59e0b',
};

export const EVENT_TYPE_LABELS: Record<string, string> = {
  meeting: 'Meeting',
  deadline: 'Deadline',
  delivery: 'Delivery',
  audit: 'Audit',
  inspection: 'Inspection',
  review: 'Review',
  training: 'Training',
  other: 'Other',
  approval_expiry: 'Approval Expiry',
  contract_renewal: 'Contract Renewal',
  qbr: 'Supplier QBR',
  // NCR-related event types (client feedback)
  ncr_response_due: 'NCR Response Due',
  ncr_car_due: 'Corrective Action Due',
  action_due: 'Action Due Date',
  audit_action_due: 'Audit Action Due',
};

export const STATUS_COLORS: Record<string, string> = {
  scheduled: 'bg-blue-100 text-blue-800',
  in_progress: 'bg-yellow-100 text-yellow-800',
  completed: 'bg-green-100 text-green-800',
  cancelled: 'bg-red-100 text-red-800',
};

export const ALL_EVENT_TYPES = [
  'meeting',
  'deadline',
  'delivery',
  'audit',
  'inspection',
  'review',
  'training',
  'other',
  'approval_expiry',
  'contract_renewal',
  'qbr',
  // NCR-related event types (client feedback)
  'ncr_response_due',
  'ncr_car_due',
  'action_due',
  'audit_action_due',
];

/**
 * Types a user can choose when adding or editing an event — the ones the
 * server stores. The rest (Approval Expiry, Contract Renewal, NCR, action and
 * audit-action deadlines) are generated from their own records and cannot be saved.
 */
export const CREATABLE_EVENT_TYPES = [
  'meeting',
  'qbr',
  'deadline',
  'delivery',
  'audit',
  'inspection',
  'review',
  'training',
  'other',
];

export const ITEMS_PER_PAGE = 10;
